
import { Component, Vue } from "vue-property-decorator";

@Component
export default class JoinComplete extends Vue {
  //data
  //computed
  //method
  //initialized events
}
